
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import get from 'lodash/get';

/**
 * Generic information reporting function based on SENTRY_FALLBACK environment variable
 *
 * @param {String} message
 * @param {Object} captureContext - optional
 */
export const reportInfoMessage = (message, captureContext) => {
  if (process.env.SENTRY_FALLBACK === 'true') {
    Vue.rollbar.info(message, get(captureContext, 'extra'));
    return;
  }

  Sentry.captureMessage(message, captureContext);
};
